import * as React from "react";
const SvgRightUpIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 22 22", xmlns: "http://www.w3.org/2000/svg", id: "memory-box-light-up-right", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 10H12V22H10V12H0V10Z" }));
export default SvgRightUpIcon;
